import { ReactNode } from 'react';
import styled, { css } from 'styled-components';

import { useSession } from '../Auth/SessionProvider';
import NavBar from './NavBar';
import TopBar from './TopBar';

export interface AppLayoutProps {
  children?: ReactNode | any;
}

const AppLayout = ({ children }: AppLayoutProps) => {
  const { user } = useSession();

  if (!user) {
    return children;
  }

  return (
    <Container>
      <TopBar />
      <NavBar />

      {children}
    </Container>
  );
};

export const Container = styled.div`
  ${({ theme }) => css`
    @media ${theme.devices.sm} {
      padding-bottom: ${theme.navBarHeight.sm + 6}px;
    }

    @media ${theme.devices.md} {
      padding-top: ${theme.navBarHeight.md}px;
    }
  `}
`;

export default AppLayout;
